<script>
import mapStylesDefault from '../vendor/google-map-snazzymaps';

export default {
    props: ['lat', 'long', 'apiKey', 'size'],
    data() {
        return {
            styleItems: [],
            separator: '|',
            _parameters: '',
            url: `//maps.googleapis.com/maps/api/staticmap?sensor=false&zoom=11&center=`
        }
    },
    beforeMount: function() {
        let params,
            markers;
        const pinUrl = `${document.location.protocol}//${document.location.host}/images/site/maps/map-pin.png`;
        let lat = this.$props.lat;
        let long = this.$props.long;
        let size = this.$props.size || "500x270";

        this.parseStyles(mapStylesDefault);
        params = this.appendStyles();
        markers = `&markers=icon:${pinUrl}%7C${lat},${long}`;
        size = `&size=${size}`;
        this.url = this.url.concat(`${lat},${long}`) + size + markers + params;
    },
    render: function(createElement) {
        return createElement(
            'img', {
                attrs: {
                    src: this.url + `&key=${this.apiKey}`,
                    class: 'img-responsive'
                }
            }
        )
    },
    methods: {
        isColor: function(value) {
            return /^#[0-9a-f]{6}$/i.test(value.toString());
        },
        toColor: function(value) {
            return '0x' + value.slice(1);
        },
        parseStyles: function(jsonString) {
            this.styleItems.length = 0;

            for (var i = 0; i < jsonString.length; i++){
                var item = jsonString[i],
                    hasFeature = item.hasOwnProperty('featureType'),
                    hasElement = item.hasOwnProperty('elementType'),
                    stylers = item.stylers,
                    target = '',
                    style = '';

                if (!hasFeature && !hasElement){
                    target = 'feature:all';
                } else {
                    if (hasFeature){
                        target = 'feature:' + item.featureType;
                    }
                    if (hasElement){
                        target = target ? target + this.separator : '';
                        target += 'element:' + item.elementType;
                    }
                }

                for (var s = 0; s < stylers.length; s++){
                    var styleItem = stylers[s],
                        key = Object.keys(styleItem)[0]; // there is only one per element

                    style = style ? style + this.separator : '';
                    style += key + ':' + (this.isColor(styleItem[key]) ? this.toColor(styleItem[key]) : styleItem[key]);
                }

                this.styleItems.push(target + this.separator + style);
            }
        },
        appendStyles: function() {
            return '&style=' + this.styleItems.join('&style=');
        }
    }
}

</script>


// WEBPACK FOOTER //
// resources/components/apps/contact-and-directions-map.vue